module.exports = __webpack_public_path__ + "media/stoppen-roken.597869ff.mp4";